import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Card, CardTypes } from 'sealink/react-components/cards';

// Currently only Experience has externalProducts
const RelatedEntriesCarousel = ({ entries, externalProducts = [] }) => {
  const allEntries = [...entries, ...externalProducts];
  const onlyOneEntry = entries.length === 1;
  const firstEntryType = entries[0].type;
  const slidesPerView = firstEntryType === 'blog' ? 2 : 3;

  return (
    <div className={onlyOneEntry ? 'container-xxl px-md-0' : undefined}>
      <Swiper
        slidesPerView={onlyOneEntry ? 1 : 1.3}
        slidesOffsetBefore={onlyOneEntry ? null : 16}
        slidesOffsetAfter={onlyOneEntry ? null : 16}
        spaceBetween={16}
        breakpoints={{
          768: {
            slidesPerView,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            allowSlideNext: false,
            allowSlidePrev: false,
          },
        }}
      >
        {allEntries.map((entry) => {
          const extraProps = {
            ...(entry.type === 'blog' && { hidePrice: true }),
            ...(entry.type === 'events' && {
              hidePrice: true,
              buttonClassName: 'btn-outline-primary',
            }),
          };
          return (
            <SwiperSlide key={entry.title}>
              {Card({ ...entry, ...extraProps })}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default RelatedEntriesCarousel;

RelatedEntriesCarousel.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape(CardTypes)),
  externalProducts: PropTypes.arrayOf(PropTypes.shape(CardTypes)),
};
